<template>
  <div class="row add-details">
    <div class="fares clearfix" v-if="fareClasses">
      <div
        v-for="fareClass in fareClasses"
        :key="fareClass.id"
        :class="'faredetails-' + fareClass.name + ' col-sm-12'"
      >
        <div class="col-sm-4">
          {{ fareClass.name }}
          <br />
          <small>{{ fareClass.description }}</small>
        </div>
        <div class="col-sm-2" v-for="fare in fareClass.fares" :key="fare.id">
          <small>{{ fare.name }}</small>
          <br />
          ${{ fare.displayCurrencyValueToDisplay }}
        </div>
      </div>
    </div>
    <div class="segment-list col-sm-12">
      <div v-for="(segment, i) of trip.segments" v-bind:key="segment.name">
        <div v-if="i != 0" class="transfer clearfix">
          <i class="fa fa-exchange"></i>
          <span class="transfer-text">
            Transfer.
            <!-- <i class="fa fa-clock-o"></i> -->
            {{ $t("waiting") }}
            {{ segment.stops[segment.stops.length - 1].minsWaiting }}
          </span>
        </div>
        <div class="schedule-name">
          {{ segment.brandName }} - {{ segment.stops[0].scheduleDisplayName }}
          <span class="segment-date">{{ segment.stops[0].departureDate }}</span>
        </div>
        <div class="itinerary">
          <p>
            <span>
              {{ segment.stops[0].name }}
              ({{ segment.stops[0].departure }})
              <i class="fa fa-long-arrow-right"></i>
            </span>
            <span v-for="(stop, j) of segment.stops" v-bind:key="stop.name">
              <span v-if="j != 0">
                {{ stop.name }}
                ({{ stop.departure }})
                <i class="fa fa-long-arrow-right"></i>
              </span>
            </span>
            <span>
              <span>{{ segment.stops[segment.stops.length - 1].to }}</span>
              ({{ segment.stops[segment.stops.length - 1].arrival }})
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["trip", "fareClasses", "showClassName", "segmentIndex"],
  data() {
    return {};
  },
};
</script>
<style lang="scss">
.segment-list {
  padding-top: 15px;
  padding-left: 50px;
  .schedule-name {
    color: $brand-primary;
    text-transform: uppercase;
    font-weight: bold;
    font-family: $font-family-base;
  }
  .segment-date {
    font-size: 13px;
    color: #6d6d6d;
    font-weight: 300;
    padding-left: 10px;
  }
  .itinerary {
    color: #6d6d6d;
    padding: 10px 0px;
    .fa {
      color: #febc11;
    }
  }

  .transfer {
    color: $brand-primary;
    padding-bottom: 15px;
    > .fa {
      color: #febc11;
    }
    .transfer-text {
      border: 1px solid #febc11;
      white-space: nowrap;
      border-radius: 2px;
      padding: 5px 20px;
      font-weight: 500;
      margin-left: 8px;
    }
  }
}
.add-details {
  transition: all 0.4s ease;
  height: 0px;
  overflow: hidden;
  opacity: 0;
  border: 1px solid #cecece;
  margin-left: 15px;
  margin-right: 15px;
}
.open .add-details,
.in .add-details {
  display: block;
  transition: all 0.4s ease;
  opacity: 1;
  height: 100%;
  margin-bottom: 20px;
  padding-bottom: 20px;
}
</style>